import axios from "axios";
import { dispatchHandler } from "../helpers/dispatchHandler";
import {
  PROJECT_CREATE_ERROR, PROJECT_VIEW_ALL, PROJECT_VIEW_ALL_ERROR,
} from "./type";
import secureLocalStorage from "react-secure-storage";

const header = {
  headers: { "access-token": secureLocalStorage.getItem("token") },
};

export const projectCreate =
  (info) =>
    async (dispatch) => {
      try {
        dispatchHandler({ type: PROJECT_CREATE_ERROR, data: null, dispatch });
        const URL = "/api/v1/e-approval/project/create";
        const formData = new FormData();
        formData.append("contractType", info.contractType);
        formData.append("name", info.name);
        formData.append("description", info.description);
        formData.append("startDate", info.startDate);
        formData.append("endDate", info.endDate);
        formData.append("amountType", info.amountType);
        formData.append("budgetAmount", info.budgetAmount);


        const response = await axios.post(URL, formData, header);

        // if (response.data) {
        //   successToast(response?.data?.message);
        // }
        if (response.status === 200) {
          window.location.replace("/project");
        }
      } catch (error) {
        dispatchHandler({
          type: PROJECT_CREATE_ERROR,
          data: error?.response?.data?.message ?? "Server Error",
          dispatch,
        });
        return null;
      }
    };

/**
 * list all projects action
 * @param {*} query 
 * @returns 
 */
export const projectViewAll =
  (query) =>
    async (dispatch) => {
      try {
        dispatchHandler({ type: PROJECT_VIEW_ALL_ERROR, data: null, dispatch });
        const URL = `/api/project/listAll`;
        const { data } = await axios.get(URL, header);
        if (data) {
          dispatchHandler({
            type: PROJECT_VIEW_ALL,
            data: data?.data,
            dispatch,
          });
        }
      } catch (error) {
        dispatchHandler({
          type: PROJECT_VIEW_ALL_ERROR,
          data: error?.response?.data.message || "Internal server error",
          dispatch,
        });
      }
    };